var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon delete",
    d: "M15.3933 1.82913C15.3933 1.37139 15.0301 1 14.58 1H8.67023C8.22011 1 7.85686 1.37139 7.85686 1.82913V3.98508H2V5.64333H3.43718V19.1857C3.43718 21.292 5.1116 23 7.17899 23H16.1261C17.1153 23 18.0642 22.5973 18.7622 21.8815C19.4591 21.1647 19.8478 20.1952 19.8404 19.1858V5.64339H21.25V3.98513H15.3931L15.3933 1.82913ZM8.72419 17.8871H7.09743V8.49033H8.72419V17.8871ZM12.4383 17.8871H10.8116V8.49033H12.4383V17.8871ZM13.7664 3.98513H9.48345V2.65831H13.7664V3.98513ZM16.1525 8.49033V17.8871H14.5258V8.49033H16.1525Z",
    fill: "#9AA0A7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDelete);
export default __webpack_public_path__ + "static/media/NewDelete.3f1303480a4efecbbeb9c4b702774fd7.svg";
export { ForwardRef as ReactComponent };